import { ReactNode } from 'react'
import { useParams } from 'react-router-dom'

import { useAgents } from '@hooks/use-agents'
import { useUser } from '@hooks/use-user';

import { ConditionalLayout } from './ConditionalLayout'

interface AgentLayoutEmbeddedLayoutProps {
    children: ReactNode
}

export function AgentLayoutEmbedded({ children }: AgentLayoutEmbeddedLayoutProps) {
    const { slug } = useParams<{ slug: string }>()
    const { getAgent, loading: agentsLoading } = useAgents()
    const { loading: userLoading } = useUser()


    const agent = getAgent(slug || '')

    // Custom not found content for agents
    const agentNotFoundContent = (
        <div className="flex items-center justify-center h-screen">
            <div className="text-center">
                <h1 className="text-2xl font-bold mb-4">Agent Not Found</h1>
                <p>The requested agent could not be found or is not available.</p>
            </div>
        </div>
    )

    return (
        <ConditionalLayout
            requireAuth={() => false}
            fallbackToLogin={false}
            minimalLayout={true} // Use minimal layout for public agents
            isLoading={agentsLoading || userLoading}
            isNotFound={!agentsLoading && !agent}
            notFoundContent={agentNotFoundContent}
        >
            {children}
        </ConditionalLayout>
    )
}